import React, { useEffect, useState } from 'react'
import Modal from 'Common/Components/Modal';
// Formik
import { Common } from 'helpers/common';
import { Loader2 } from 'lucide-react';
import { ProductVariantInventoryType, ProductVariantType } from 'types/ProductVariantType';
import Select, { SelectInstance } from 'react-select';
import Cleave from "cleave.js/react";
import { set } from 'date-fns';
import { updateProductVariant } from 'helpers/backend_helper';

type Props = { onHide: () => void; data: ProductVariantInventoryType[], onSave: (result: any) => void, productName: string }

const UpdateInventory: React.FC<Props> = ({ onHide, data, onSave, productName }) => {

    const [isEdit, setIsEdit] = useState<boolean>(false);

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const commonHelper = new Common();
    const [errors, setErrors] = useState<any>({});
    // const productData=[
    //     { productId:1, id: 1, productSize: 'XL', color: 'blue', inventory: 10 },
    //     { productId:1, id: 1, productSize: 'L', color: 'orange', inventory: 20 },
    //     { productId:1, id: 1, productSize: 'M', color: 'red', inventory: 8 },
    //     { productId:1, id: 1, productSize: 'S', color: 'gray', inventory: 0 },
    // ]

    const [productDataState, setProductDataState] = useState<ProductVariantInventoryType[]>(data);
    const [inventoryUpdates, setInventoryUpdates] = useState<any>({});

    const handleInventoryUpdate = (e: any, row: ProductVariantInventoryType) => {
        setInventoryUpdates({ ...inventoryUpdates, [row.id + '-' + row.productSize]: e.target.value });
    }

    console.log('productDataState', data);

    const handleUpdateInventory = async () => {
        setIsSaving(true);
        const updatedRows = productDataState.map(row => {
            const inventoryUpdate = inventoryUpdates[row.id + '-' + row.productSize];
            if (inventoryUpdate !== undefined) {
                return { ...row, inventory: inventoryUpdate===""?0:inventoryUpdate };
            }
            return row;
        });
        try {
            for (const row of updatedRows) {
                const data = { id: row.id, inventory: row.inventory, unitPrice: row.unitPrice };
                await updateProductVariant(data);
                console.log(row, data);
            }
            setProductDataState(updatedRows);
            setInventoryUpdates({});
            onSave(updatedRows);
            console.log('onsave')
            setIsSaving(false);
        } catch (error) {
            console.log(error);
            setIsSaving(false);
        }
    }

    const renderColors = (colors: string[]) => {
        return colors.map(color => (
            <div key={color} style={{ backgroundColor: color, width: '20px', height: '20px', borderRadius: '5px', marginRight: '10px', display: 'inline-block' }}></div>
        ));
    }

    const renderRows = () => {
        return productDataState.map(row => (
            <tr key={row.id + '-' + row.productSize}>
                <td className='px-4 py-1 border border-custom-100 dark:border-custom-900'>{row.productSize}</td>
                <td className='px-4 py-1 border border-custom-100 dark:border-custom-900'>{renderColors(row.color)}</td>
                <td className='px-4 py-1 border border-custom-100 dark:border-custom-900'>
                    <Cleave id="inventory" className="form-input border-slate-200 w-20 border dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="100"
                        onChange={(e: any) => { handleInventoryUpdate(e, row) }}
                        onBlur={handleBlur}
                        value={row.inventory || 0}
                        min={0}
                        autoComplete='off'
                        maxLength={5}
                        options={{
                            numeral: true, 
                            numeralDecimalScale: 0,
                            numeralThousandsGroupStyle: "none"
                        }}
                    />
                    {errors.inventory ? (
                        <div id="inventory-error" className="mt-1 text-sm text-red-500">{errors.inventory}</div>
                    ) : null}
                </td>
            </tr>
        ));
    }



    const handleBlur = (e: any) => {

    }


    return (
        <React.Fragment>
            <Modal.Header className="bg-custom-200 dark:bg-custome-700 flex items-center justify-between p-4 border-b dark:border-zink-300/20"
                closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
                <Modal.Title className="text-16">Inventory Update -       Product : {productName}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                    <div className="xl:col-span-12">
                        {/* <label htmlFor="inventory" className="inline-block mb-2 text-base font-medium">Product : {productName}</label> */}
                        <table className="table-auto w-full border-separate border-spacing-0 border border-custom-100 dark:border-custom-900">
                            <thead className="bg-slate-100 dark:bg-slate-700">
                                <tr>
                                    <th className="px-4 py-2 border border-custom-100 dark:border-custom-900">Size</th>
                                    <th className="px-4 py-2 border border-custom-100 dark:border-custom-900">Color</th>
                                    <th className="px-4 py-2 border w-20 border-custom-100 dark:border-custom-900">Inventory</th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderRows()}
                            </tbody>
                        </table>

                    </div>
                </div>

                <div className="flex justify-end gap-2 mt-4">
                    <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={onHide}>Cancel</button>

                    {!isSaving ?
                        <button type="button"
                            onClick={() => handleUpdateInventory()}
                            className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                            {"Update Inventory"}

                        </button>
                        : <button type="button" disabled className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                            <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                            Saving...
                        </button>
                    }

                </div>

            </Modal.Body>
        </React.Fragment >
    )
}

export default UpdateInventory;